import React from "react";
import ReactDom from "react-dom";

import EmailSignupModalApp from "./EmailSignupModalApp.jsx";

export default function renderEmailSignupModal() {
  document.querySelectorAll(".js-email-signup-modal").forEach((el) => {
    if (window.sessionStorage.getItem("hideInterstitial")) {
      return;
    }

    const content = el.children || [];
    const lang = el.getAttribute("lang") || "";
    const dir = el.getAttribute("dir");
    const scrollDepth = parseInt(el.dataset.scrollDepth, 10) || 50;

    const mount = document.createElement("div");
    document.querySelector("body").append(mount);

    ReactDom.render(
      <EmailSignupModalApp
        content={content}
        scrollDepth={scrollDepth}
        lang={lang}
        dir={dir}
      />,
      mount,
    );
  });
}
